import React from 'react';
// 1. Importamos el ícono 'Sparkles' desde la librería lucide-react
import { Sparkles } from 'lucide-react';

/**
 * Un componente para mostrar de forma elegante el análisis generado por IA.
 * Maneja el estado de carga/vacío, muestra un disclaimer y usa íconos de Lucide.
 * @param {{ explicacion: string | null | undefined }} props
 */
const AnalisisIA = ({ 
  explicacion,
  mensajeAdvertencia,
 }) => {

  // Comprobamos si la explicación es válida (no es nula, indefinida o un string vacío)
  const tieneContenido = explicacion && explicacion.trim().length > 0;

  return (
    <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 my-4 shadow-sm">
      
      {/* Cabecera del componente con el ícono de Lucide */}
      <div className="flex items-center mb-3">
        <Sparkles className="inline-block mr-2 text-indigo-500 flex-shrink-0" size={22} />
        <h3 className="text-lg font-bold text-indigo-800">Análisis con IA</h3>
      </div>

      {/* Contenido condicional */}
      <div className="text-sm text-indigo-900 ml-1">
        {tieneContenido ? (
          // Si hay contenido, lo mostramos.
          // La clase 'whitespace-pre-wrap' es CLAVE para que respete los saltos de línea (\n).
          <div className="whitespace-pre-wrap font-mono bg-indigo-100 p-3 rounded-md border border-indigo-200">
            {explicacion}
          </div>
        ) : (
          // Si no hay contenido, mostramos el mensaje que solicitaste.
          <p className="italic text-indigo-600 px-2 py-1">
            La explicación por IA aún no está disponible. El análisis se está procesando...
          </p>
        )}
      </div>
      
      {/* Disclaimer - Se muestra siempre, con el texto que indicaste */}
      <div className="mt-4 text-xs text-indigo-700 italic border-t border-indigo-200 pt-3">
        <p>
          <strong>Aviso:</strong> El trabajo se analizó con IA para ayudarte, mas esto podría tener errores. Usa esta información bajo tu propia responsabilidad.
        </p>
      </div>

    </div>
  );
};

export default AnalisisIA;
